import { ArrowRight } from "lucide-react";

export default function FinalCTA({ onBook }) {
    return (
        <section
            id="final-cta"
            className="relative py-24 sm:py-32 bg-[#0A0A0A] text-white border-t border-white/5 overflow-hidden"
        >
            <div className="absolute inset-0 hero-grid opacity-60 pointer-events-none" />
            <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center reveal">
                <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl text-white leading-[0.98]">
                    Stop running compliance in pieces.
                </h2>
                <p className="mt-6 text-lg sm:text-xl text-zinc-300 max-w-3xl mx-auto leading-relaxed">
                    Book a working session with our enterprise team. We will
                    walk a real project scenario through the platform and show
                    you what consolidated, AI-driven Tier 1 compliance looks
                    like.
                </p>
                <div className="mt-9 flex flex-col sm:flex-row gap-3 justify-center">
                    <button
                        onClick={onBook}
                        className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-lg bg-[#1FA8FF] text-white font-semibold hover:bg-[#0C84D4] transition-colors"
                        data-testid="final-book-demo"
                    >
                        Book a demo
                        <ArrowRight className="w-4 h-4" />
                    </button>
                    <button
                        onClick={onBook}
                        className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-lg border border-white/25 text-white font-semibold hover:bg-white/5"
                        data-testid="final-talk-sales"
                    >
                        Talk to enterprise sales
                    </button>
                </div>
            </div>
        </section>
    );
}
